import { render, staticRenderFns } from "./WireTransferInput.vue?vue&type=template&id=b03ce8dc&scoped=true&"
import script from "./WireTransferInput.vue?vue&type=script&lang=js&"
export * from "./WireTransferInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03ce8dc",
  null
  
)

export default component.exports